import { MedicalLeavePuePayer } from '@dreryk/egabinet-ezla-frontend-api';

import { createInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';
import { ellipsify, Multiselect } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';

import { MAX_PAYER_NAME_LENGTH } from './payerSection.constants';

type PuePayerMultiselectItemProps = {
   readonly payer: MedicalLeavePuePayer;
};

export const PuePayerMultiselectItem = ({ payer }: PuePayerMultiselectItemProps): JSX.Element => {
   const translate = useTranslate();
   return (
      <Multiselect.Item<MedicalLeavePuePayer>
         item={payer}
         testId={payer.identificationNumber}
         label={createInterpolatedTranslationKey(commonTranslationKeys.payerNameAndIdentification, {
            name: ellipsify(payer.name || '', MAX_PAYER_NAME_LENGTH),
            identificationType: translate(commonTranslationKeys[payer.identificationNumberType]),
            identificationNumber: payer.identificationNumber,
         })}
      />
   );
};
